import { Event, EventType } from "./Event";

import type { IAddCartaddEvent } from "./types";

export class AddCartaddEvent extends Event {
  constructor({ itemId, tracking, customEventProperties }: IAddCartaddEvent) {
    super({
      event_type: EventType.cartadd,
      event_properties: {
        item_id: itemId,
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
